<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-folder-download`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M20.764 6a2 2 0 011.789 1.106L24 10h19.905c1.157 0 2.095.895 2.095 2v28c0 1.105-.938 2-2.095 2H4.095C2.938 42 2 41.105 2 40V8a2 2 0 012-2h16.764zM42 14H6v24h36V14zm-16.916 3a1 1 0 011 1v10.33l2.937-2.937a1 1 0 011.414 0l1.414 1.415a1 1 0 010 1.414l-7.07 7.07a1 1 0 01-1.415 0l-7.071-7.07a1 1 0 010-1.414l1.414-1.415a1 1 0 011.414 0l2.963 2.965V18a1 1 0 011-1h2z"/></svg>
</template>
<script>

export default {
  name: 'IconFolderDownload',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
